/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OfflineInputs */

const en_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

const fr_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors ligne`)
};

const de_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

const it_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuori linea`)
};

const ru_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Офлайн`)
};

const es_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconectado`)
};

const zh_cn2_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线`)
};

const ja_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフライン`)
};

const hi_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफलाइन`)
};

const pt_pt2_offline = /** @type {(inputs: OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

/**
* | output |
* | --- |
* | "Offline" |
*
* @param {OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline = /** @type {((inputs?: OfflineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OfflineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline(inputs)
	if (locale === "de") return de_offline(inputs)
	if (locale === "it") return it_offline(inputs)
	if (locale === "ru") return ru_offline(inputs)
	if (locale === "es") return es_offline(inputs)
	if (locale === "zh-CN") return zh_cn2_offline(inputs)
	if (locale === "ja") return ja_offline(inputs)
	if (locale === "hi") return hi_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_offline(inputs)
	return en_offline(inputs)
});